import { createSlotRecipe } from './runtime.js';

const sidePanelConfig = {"name":"sidePanel","slots":["root","main","panel","panelInner","header","title","description","body","footer"],"defaultVariants":{"divider":"line"},"variantMap":{"divider":["gap","line"]}}

export const sidePanel = /* @__PURE__ */ createSlotRecipe(sidePanelConfig)